import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { TextArea } from 'ui-components/common/TextArea';
import { FontWeight, Typography } from '@diritto/common/style/typography';

export const ContentTextArea = styled(TextArea)`
  border: 1px solid ${Color.Gray300};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 10px;
  resize: vertical;

  ${Typography.XXSmall};
  font-weight: ${FontWeight.Regular};

  &:focus {
    outline: none;
    border: 1px solid ${Color.Primary500};
  }
`;
